import SeoContext from '../../lib/seo-context';
import { fetchAPI } from '../../lib/api';
import Link from 'next/link';
import Layout from '../../components/layout';
import HeroProduct from '../../components/hero-product';
import SectionTree from '../../components/section-tree';
import Cta from '../../components/cta';
import { Merge } from '../../lib/helper';
import { useGlobalContext } from '../../lib/global-context';

import TestimonialList from '../../components/testimonial-list';
const Product = (props) => {
    const { state } = useGlobalContext();
    const { pageProps, global } = props;

    if (!pageProps) {
        return '';
    }

    const seo = Merge(global.seo, pageProps.seo);
    seo.canonicalURL = `${process.env.NEXT_PUBLIC_SITE_URL}/products/${pageProps.slug}`;
    const sections = [pageProps.topSection, pageProps.trustSection, pageProps.bottomSection];

    return (
        <SeoContext.Provider value={seo}>
            <Layout
                footerClass="skew-maturity-100"
                languageData={{ originalSlug: pageProps.originalSlug, languages: pageProps.localizations }}
            >
                <HeroProduct {...pageProps} />
                <>
                    {sections.map((section, sindex) => (
                        <>
                            {sindex == 1 && (
                                <section key={`psection-${sindex}`} className="trust">
                                    <div className="relative z-1">
                                        <div className="skew-top-left"></div>
                                        <div className="relative bg-gradient-trust-left">
                                            <div className="container pt-40 pb-20 md:pt-20 ">
                                                <SectionTree isTrust={true} key={`section-top-tree-${sindex}`} section={section}></SectionTree>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            )}

                            {sindex != 1 && (
                                <SectionTree key={`section-top-tree-${sindex}`} section={section}></SectionTree>
                            )}
                        </>
                    ))}
                </>

                <Cta className="bg-maturity-100 relative pt-24 pb-8 text-center" skewBottom={false}>
                    <p className="text-trust-900 text-3xl normal-case py-8 w-2/3 mx-auto font-semibold">
                        Do you want to know more about our products?
                    </p>
                    <Link href="/contact">
                        <a className="btn action-full !text-base !px-10 !py-4">Let&apos;s get in touch</a>
                    </Link>
                </Cta>
            </Layout>
        </SeoContext.Provider>
    );
};

export async function getStaticPaths({ locales }) {
    const paths = [];
    await Promise.all(
        locales.map(async (locale) => {
            const results = await fetchAPI('/products', { locale, populate: 'deep,1' });
            return results.data.map((page) => {
                return paths.push({
                    params: {
                        slug: page.attributes.slug
                    },
                    locale
                });
            });
        })
    );

    return {
        paths,
        fallback: true
    };
}

export async function getStaticProps({ params, locale }) {
    try {
        const result = await fetchAPI(`/products/by-slug/${params.slug}`, {
            populate: 'deep,4',
            locale
        });

        return {
            props: { pageProps: result.data.attributes },
            revalidate: Number(process.env.NEXT_PUBLIC_PAGE_REVALIDATION) || 100
        };
    } catch (e) {
        console.log('got an error', e.message);
        return { notFound: true };
    }
}

export default Product;
